class Device {
    static get instance () {
        if(!Device._instance) { Device._instance = new Device();}
        return Device._instance;
    }
    
    constructor() {
    }

    isTouch() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function(query) {
            return window.matchMedia(query).matches;
        }
        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }

    isScreenDesktop(){
        var menuBreakpoint = 1124;
        return window.innerWidth >= menuBreakpoint;
    }
}

export default Device;